import * as React from 'react';

const styles = require('./styles.css');

export const ProlongationPopupHeader = () => <h3 className={styles['header']}>Служба качества ЦИАН</h3>;
